module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "u4zoQDQRnQ8rS44kuKdA6L9",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "udSV95ovyJWlaSjPhaeRwQ5"
    }
  }), _vm._v("1: The Scoop")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The tone in his voice gave away his trepidation when he asked, “Will you please see if Pete Marudas is in "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("The Tribune ")]), _vm._v("press room?”"), _c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    staticClass: "Footnote-reference"
  }, [_c('span', {
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-007"
    }
  }, [_vm._v("(5)")])])])]), _vm._v(" The nervous newsman could hear voices at the other end of the line and realized the phone was in the kitchen of a small diner in Cheboygan called The Hut. The local cafe was a mere fifteen miles from Mackinac Island, across Lake Huron to Michigan’s mainland, but at the moment, it seemed a world away.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With a population just shy of six thousand people in 1960, Cheboygan was home to the"), _c('span', {
    staticClass: "italics"
  }, [_vm._v(" Daily Tribune")]), _vm._v(", a local paper, and the pages for the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island Town Crier")]), _vm._v(" were printed there once each week.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The staffer had tried frantically to call the"), _c('span', {
    staticClass: "italics"
  }, [_vm._v(" Daily Tribune")]), _vm._v(" directly, and he quickly realized the main office had closed at 6:00 p.m. There had to be a way to get in touch with his colleague. He remembered the small restaurant only two doors away from their office, and he desperately dialed the number, hoping to convince someone to run the short distance and check for him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Two on one, hold the onions,” he heard in the background."), _c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "id": "footnote-006-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-006"
    }
  }, [_vm._v("(6)")])])]), _vm._v(" Sitting in the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Town Crier ")]), _vm._v("office, he looked at his watch and tapped his fingers on the desk as he waited impatiently. Minutes were ticking away, and he knew time was of the essence.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Five minutes passed, and it seemed like an eternity. Someone picked up the phone. “Yes, he’s there,” came a voice at the other end of the line.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was an awkward silence as the newsman waited for the next sentence; the line remained silent. Incredulous, he asked, “Could I speak to him, please?” The man who answered the phone had only checked to see if Marudas was at "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("The Daily Tribune")]), _vm._v(". He didn’t tell him there was a phone call for him. Frustration set in.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Another five minutes of waitresses barking menu orders and dishes clanking in the kitchen passed. To the newsman, it was as if time had come to a complete standstill. He was hoping they hadn’t forgotten him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Just ninety minutes earlier, he’d become suspicious. While transportation during the tourism season at Michigan’s premier resort destination was limited to horse and carriage, bicycle, or foot travel, many tourists didn’t know there were seldom-seen emergency vehicles on Mackinac Island. Aside from fire trucks and a police Jeep, there was also an ambulance, and he’d seen both vehicles heading toward Lake Shore Road along the west side of the four-square-mile resort island. Given the week’s chaos, he instinctively knew something was up, and the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Town Crier")]), _vm._v(" staff member grabbed a bike. He raced down Market Street to the west until he reached the intersection at Lake Shore Road. Making the turn and leaving the resort city, it became M-185, the only state highway in Michigan where private autos are banned. Pedaling as fast as he could, he was headed toward British Landing along the west side of the Island.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Michigan State Police had an office at the Mackinac Island Coast Guard Station, and he’d already sent a colleague in that direction to see what he could find out. Now a mile from town, he raced past Devil’s Kitchen, a large geologic outcropping and well-known tourist attraction.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was still no sign of the two emergency vehicles. He followed the gentle curves lined by Lake Huron on the left and steep bluffs with hundreds of cedar trees on the right.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The narrow road made a sharp turn to the right in a northwesterly direction, and he could see a soft curve ahead that turned almost directly to the north. He rounded the curve, and both bicycle tires slid on the pavement as he squeezed the hand brakes.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The police Jeep and the Island’s ambulance were stopped in the road, and men dressed in suits were milling around with a couple of uniformed Michigan State Police troopers. On the east side of the road, two small cobblestone fences framed the start of a short path leading to two stone pillars with a large iron gate between them. The small group of men stood in front of it as they quietly talked among themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By 9:00 p.m., his suspicions were confirmed, and he raced back to the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island Town Crier")]), _vm._v(" office to catch Marudas before the pages went to print.")]), _vm._v(" "), _c('p', {
    staticClass: "Divider",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "Normal-Spaced",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After an agonizingly long wait listening to clattering dishes and waitresses yelling to short-order cooks, he finally heard Marudas at the other end of the line. His colleague had barely said the word "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("hello")]), _vm._v(" when the newsman yelled, “Stop the presses!” Without a breath between sentences, he rattled off instructions to Marudas saying, “We’ve got to make over the entire front page and the banner.”"), _c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "id": "footnote-005-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-005"
    }
  }, [_vm._v("(7)")])])]), _vm._v(" After a quick recap of what he’d found out up to that point, both men knew it was going to be a very long night.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Over the previous three hot July days, with local reporters grasping at every bit of information that came out through the State Police and the Mackinac Island Police Department, the Island’s weekly laid-back paper had almost felt as if it had become a daily edition.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The ten-cent paper, published every Friday during the summer, covered all of the previous week’s events, and just six days before, the modest weekly featured stories covering the start of the Chicago-to-Mackinac yacht race and the excitement of the visiting guests on the Island to watch the arrival of the winners. Other short articles mentioned the new police chief appointed by city council, the upcoming Christmas in July Bazaar, and picnickers who had enjoyed a visit to Devil’s Kitchen on the west lakeshore in 1937. Another short feature mentioned Governor G. Mennen Williams’ arrival for a short stay at the governor’s mansion just the day before.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Now, on Thursday night, the news spread quickly, and there was a constant barrage of interruptions as the phone continued to ring at the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Town Crier")]), _vm._v(" offices for updates from media outlets around the state. The small staff worked tirelessly past midnight as they added new information and made updates to the story as they learned additional details.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Hours later, the staffer was back on the phone and told Marudas, “Get these papers over here early tomorrow morning, whatever you have to do.”"), _c('span', {
    staticClass: "CharOverride-8"
  }, [_c('span', {
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-004"
    }
  }, [_vm._v("(8)")])])]), _vm._v(" It was past midnight, and he’d lost all sense of time. He knew that if the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Town Crier")]), _vm._v(" hit the streets early in the morning, it would be the first paper to report the breaking news.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By 7:30 a.m., Pete Marudas, now near exhaustion, was still in Cheboygan finishing the print. He wouldn’t make it back to the Island until he could catch the first ferry of the day. He loaded the final copy in his car and made the nineteen-minute drive back to Mackinaw City in record time, knowing he had to make it on the first ferry to the Island. Hurrying to the dock, he could see several newsmen from around the state already waiting to be ferried to Mackinac Island. Marudas quietly boarded with them, silently pushing his cart loaded with the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Town Crier")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By 9:00 a.m., with temperatures already in the mid-seventies and expected to reach the low nineties later in the day, Marudas rolled the pushcart loaded with the special edition across the front porch of the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island Town Crier")]), _vm._v(", and at 9:03, the first edition hit the streets.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Marudas had done it. This would be the biggest story published by the small newspaper since it first began circulation on the Island just three years earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The original headline was supposed to read “"), _c('span', {
    staticClass: "SmallCap"
  }, [_vm._v("Missing Widow Still Stumps Police")]), _vm._v(".” The revised headline read “"), _c('span', {
    staticClass: "SmallCap"
  }, [_vm._v("Widow’s Beaten Body Found.")]), _vm._v("”")]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "footnote-007"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-007-backlink"
    }
  }, [_vm._v("5")]), _vm._v(". "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island Town Crier")]), _vm._v(", “Big Story Puts Town Crier Staff in Tizzy, But It Still Scoops State,” August 7, 1960")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-006"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-006-backlink"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('a', {
    attrs: {
      "id": "uA3slCgQJss4AgSOYjGygC2"
    }
  }), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island Town Crier")]), _vm._v(", “Big Story Puts Town Crier Staff in Tizzy, But It Still Scoops State,” August 7, 1960")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-005"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-005-backlink"
    }
  }, [_vm._v("7")]), _vm._v(". "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island Town Crier")]), _vm._v(", “Big Story Puts Town Crier Staff in Tizzy, But It Still Scoops State,” August 7, 1960")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-004"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chapter_01#footnote-004-backlink"
    }
  }, [_vm._v("8")]), _vm._v(". "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Mackinac Island Town Crier")]), _vm._v(", “Big Story Puts Town Crier Staff in Tizzy, But It Still Scoops State,” August 7, 1960")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-461c5c10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter_01.vue
// module id = 87
// module chunks = 0